module.exports = __webpack_public_path__ + "static/barbarawork6-648f5e255dfdfe066796b0edf543db1a.jpg";